import React, { useState } from "react";
import { Link } from "gatsby";
import * as styles from "./style.module.scss";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { Button, Col, Row } from "react-bootstrap";

const ServicesMb = () => {
  const NavBarData = [
    {
      mobileLabel: "View All",
      label: "Services",
      link: "/services/",
      disabled: false,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/smart-contract-development/",
          label: "Smart Contract",
          disabled: false,
        },
        {
          link: "/blockchain-consulting-services/",
          label: "Blockchain Consultancy",
          disabled: false,
        },
        {
          link: "/enterprise-blockchain-development/",
          label: "Enterprise Blockchain Development",
          disabled: false,
        },
        {
          link: "/web3-development-services/",
          label: "Web3 Development Services",
          disabled: false,
        },
        {
          link: "/token-development-services/",
          label: "Token Development",
          disabled: false,
        },
        {
          link: "/dapp-development-services/",
          label: "DApp Development",
          disabled: false,
        },
        {
          link: "/defi-platform-development/",
          label: "DeFi Development",
          disabled: false,
        },
        {
          link: "/nft-development-services/",
          label: "NFT Development",
          disabled: false,
          dropdown: true,
          subMenu: [
            {
              link: "/smart-contract-development/",
              label: "Smart Contract",
              disabled: false,
            },
            {
              link: "/blockchain-consulting-services/",
              label: "Blockchain Consultancy",
              disabled: false,
            },
          ],
        },
        {
          link: "/crypto-marketing-services/",
          label: "Crypto Marketing",
          disabled: false,
        },
        {
          link: "/dao-development-services/",
          label: "DAO Development",
          disabled: false,
        },
      ],
    },
    {
      mobileLabel: "View All",
      label: "Blockchain",
      link: "/blockchain/",
      disabled: false,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/solana-blockchain-development/",
          label: "Solana Blockchain",
          disabled: false,
        },
        {
          link: "/substrate-development-services/",
          label: "Substrate Development",
          disabled: false,
        },
        {
          link: "/binance-smart-chain-development/",
          label: "Binance Development",
          disabled: false,
        },
        {
          link: "/polygon-blockchain-development/",
          label: "Polygon Development",
          disabled: false,
        },
        {
          link: "/polkadot-blockchain-development/",
          label: "Polkadot Development",
          disabled: false,
        },
        {
          link: "/ethereum-blockchain-development/",
          label: "Ethereum Development",
          disabled: false,
        },
        {
          link: "/cosmos-blockchain-development/",
          label: "Cosmos Development",
          disabled: false,
        },
        {
          link: "/algorand-blockchain-development/",
          label: "Algorand Development",
          disabled: false,
        },
        {
          link: "/hyperledger-blockchain-development/",
          label: "Hyperledger Development",
          disabled: false,
        },
        {
          link: "/cardano-blockchain-development/",
          label: "Cardano Development",
          disabled: false,
        },
      ],
    },
    {
      mobileLabel: "View All",
      label: "Technologies",
      link: "/technologies/",
      disabled: false,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/hire-hyperledger-developers/",
          label: "Hire Hyperledger Developers",
          disabled: false,
        },
        {
          link: "/hire-rust-developers/",
          label: "Hire Rust Developers",
          disabled: false,
        },
        {
          link: "/hire-solidity-developers/",
          label: "Hire Solidity Developers",
          disabled: false,
        },
        {
          link: "/hire-golang-developers/",
          label: "Hire GoLang Developers",
          disabled: false,
        },
        {
          link: "/hire-nft-developer/",
          label: "Hire NFT Developers",
          disabled: false,
        },
        {
          link: "/hire-web3-developers/",
          label: "Hire Web3 Developers",
          disabled: false,
        },
        {
          link: "/hire-blockchain-developers/",
          label: "Hire Blockchain Developers",
          disabled: false,
        },
        {
          link: "/hire-javascript-developers/",
          label: "Hire Javascript Developers",
          disabled: false,
        },
        {
          link: "/hire-mern-stack-developer/",
          label: "Hire MERN Stack Developer",
          disabled: false,
        },
        {
          link: "/hire-mean-stack-developer/",
          label: "Hire MEAN Stack Developer",
          disabled: false,
        },
      ],
    },
  ];

  const [selectedItem, setSelectedItem] = useState(null);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const handleItemClick = (item) => {
    setSelectedItem(item);

    if (item.dropdown && item.subMenuType === "list") {
      if (openSubmenu === item.label) {
        setOpenSubmenu(null);
      } else {
        setOpenSubmenu(item.label);
      }
    }
  };

  return (
    <div>
      <div className={styles.Dropdowns}>
        {NavBarData.map((item, index) => (
          <div key={index} className={styles.dropdownItem}>
            <span
              onClick={() => handleItemClick(item)}
              className={styles.dropdownText}
            >
              {item.label}
              {!(openSubmenu === item.label) ? (
                <FaChevronRight
                  className={styles.dropdownIcon}
                  style={{ width: "7px" }}
                />
              ) : (
                <FaChevronDown
                  className={styles.dropdownIcon}
                  style={{ width: "10px" }}
                />
              )}
            </span>
            {item.dropdown &&
              item.subMenuType === "list" &&
              openSubmenu === item.label && (
                <>
                  {item.subMenu.map((submenuItem, subIndex) => (
                    <Row key={subIndex} className={styles.menuItem}>
                      <Col
                        xs={2}
                        md={2}
                        className="d-flex align-items-center justify-content-center px-0"
                      >
                        <div className={styles.menuCircle}></div>
                      </Col>
                      <Col xs={10} md={10} className={styles.submenuItem}>
                        <Link
                          to={submenuItem.link}
                          className={styles.subMenuLink}
                        >
                          {submenuItem.label}
                        </Link>
                      </Col>
                    </Row>
                  ))}
                  <div className={`${styles.viewallBtnWrap}`}>
                    <Link
                      to={item.link}
                      className={`btnRadius ${styles.viewallBtn}`}
                    >
                      <span>View All</span>
                    </Link>
                  </div>
                </>
              )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesMb;
